import type { PageCard } from '@/play/pageTypes'
import { ReadingShelfCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'reading-shelf',
  number: 26,
  title: 'Reading shelf',
  question: 'Do letter blocks read aloud when they sit on a shelf make a child want to build words?',
  status: 'open',
  accent: '#cfe3f2',
  CardArt: ReadingShelfCardArt,
}
